
<div class="mat-dialog-content">
  <div style="margin-bottom: 1.5rem; padding:0;">
      <span class="title-3">
        <span>Verifica le informazioni e conferma</span>
      </span>
  </div>

  <div class="dialog-header">
    <p style="margin-bottom: 0.5rem;">Premio selezionato</p>
    <h5>{{ data.reward.name }}</h5>
  </div>

  <div class="dialog-body">
    <div class="dialog-left"><img [src]="data.reward.image" style="width: 100%; height: auto;"  alt=""></div>

    <div class="dialog-right">
      <span class="title-3">I tuoi dettagli</span>
      <div class="point-summary">
            <span>
              <span>Totale Punti:</span>
              {{ data.points.balance }}
            </span>
        <span>
              <span>Punti richiesti per il premio:</span>
              <span>{{ data.reward.points }} </span>
            </span>

        <strong class="point-results">
          <span>Punti rimanenti:</span>
          {{ data.points.balance - data.reward.points }}
        </strong>
      </div>
    </div>

    <div class="dialog-left">
      <p>{{ data.reward.description  }}</p>
    </div>

    <div class="dialog-right">
      <div style="display: flex; flex-direction: column;">
        <span class="title-3">Invia premio a</span>
        <p class="text-subtitle"><i><small>
          Cicca qui per inserire o modificare l'indirizzo email a cui inviare il premio
        </small></i></p>
        <mat-form-field style="width: 100%;" appearance="outline">
          <input
            autofocus=""
            #emailInput
            matInput
            type="email"
            [(ngModel)]="data.send_to"
            [email]="true"
            [matAutocomplete]="auto"
            required
          >
          <mat-error>Please enter a valid email address</mat-error>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of options" [value]="option">{{option}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="actions">
        <button
          style="width:100%;"
          class="btn btn-pollstar btn-gradient-orange"
          (click)="confirm()"
        >Ottieni con {{ data.reward.points }} punti</button>
      </div>

    </div>
  </div>
</div>
